'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var component$f = require('./component-5bca3e99.js');
var component$n = require('./component-a38ceb34.js');

var PADDING_INDEX = {
    top: 0,
    right: 1,
    bottom: 2,
    left: 3,
};
var DEFAULT_PADDINGS = ['72px', '56px', '24px', '56px'];
var StyledModalContainer = styled__default(component$n.ModalWrapper)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: calc(100% * (2 / 3));\n\n  @media screen and (max-width: ", ") {\n    width: 100%;\n  }\n"], ["\n  width: calc(100% * (2 / 3));\n\n  @media screen and (max-width: ", ") {\n    width: 100%;\n  }\n"])), constants.DIMENSIONS.MEDIUM);
var ContentContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: calc(100% - ", " - ", ");\n  padding: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding-bottom: 54px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: calc(100% - ", " - ", ");\n  padding: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding-bottom: 54px;\n  }\n"])), DEFAULT_PADDINGS[PADDING_INDEX.top], DEFAULT_PADDINGS[PADDING_INDEX.bottom], DEFAULT_PADDINGS.join(' '), constants.DIMENSIONS.MEDIUM);
var ButtonContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media screen and (max-width: ", ") {\n    margin: 0;\n    padding: 8px 0 12px 0;\n    width: 100%;\n    position: fixed;\n    justify-content: center;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: ", ";\n    box-shadow: 0px 2px 4px ", "40;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media screen and (max-width: ", ") {\n    margin: 0;\n    padding: 8px 0 12px 0;\n    width: 100%;\n    position: fixed;\n    justify-content: center;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: ", ";\n    box-shadow: 0px 2px 4px ", "40;\n  }\n"])), constants.DIMENSIONS.MEDIUM, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var templateObject_1, templateObject_2, templateObject_3;

var DoublePaneModal = function (_a) {
    var isVisible = _a.isVisible, LeftPane = _a.LeftPane, RightPane = _a.RightPane, onPressButton = _a.onPressButton, buttonText = _a.buttonText, buttonEnabled = _a.buttonEnabled, showBackButton = _a.showBackButton, onPressBack = _a.onPressBack, onClose = _a.onClose, className = _a.className;
    var buildContent = function () { return (React__default.createElement(ContentContainer, null,
        React__default.createElement(component$f.DoublePane, { LeftPane: LeftPane, RightPane: RightPane }),
        React__default.createElement(ButtonContainer, null,
            React__default.createElement(button.Button, { text: buttonText, disabled: !buttonEnabled, size: "md", onClick: onPressButton })))); };
    return (React__default.createElement(StyledModalContainer, { content: buildContent(), visible: isVisible, withExitButton: true, onClose: onClose, withBackButton: showBackButton, onPressBack: onPressBack, className: className }));
};
DoublePaneModal.defaultProps = {
    buttonEnabled: true,
    showBackButton: false,
};

exports.DoublePaneModal = DoublePaneModal;
